import React, { Component } from 'react';

export default class view extends Component {
	constructor(props) {
		super(props)
	}
	render() {
		return (
			<div style={{ textAlign: 'left', overflowWrap: 'break-word' }}>
				<h3 style={{ textAlign: 'center' }}>Prior Authorization Successful</h3>
				<hr />
				<p style={{ textAlign: 'center' }} >The Prior Authorization number is:</p>
				<div style={{ textAlign: 'center', fontSize: '2em' }}>{this.props.data.PANumber}</div>
				<br />
				<p>You must write this number on the face of the prescription and enter it into the patient’s medical record. Reminder: The diagnosis code must be written on the script by the ordering provider.</p>
			</div>
		);
	}
}